import React from 'react'
import ReactDOM from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ConfigProvider, theme } from 'antd'
import zhTW from 'antd/locale/zh_TW'
import App from './App'
import './styles/global.css'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
})

// 深色科技主題設定
const darkThemeConfig = {
  algorithm: theme.darkAlgorithm,
  token: {
    colorPrimary: '#6366f1',
    colorBgContainer: '#161b22',
    colorBgElevated: '#1e293b',
    colorBgLayout: '#0d1117',
    colorBorder: 'rgba(99, 102, 241, 0.3)',
    colorBorderSecondary: 'rgba(99, 102, 241, 0.2)',
    colorText: '#f1f5f9',
    colorTextSecondary: '#94a3b8',
    colorTextTertiary: '#64748b',
    borderRadius: 8,
    colorLink: '#22d3ee',
    colorLinkHover: '#67e8f9',
  },
  components: {
    Menu: {
      darkItemBg: '#161b22',
      darkSubMenuItemBg: '#0d1117',
      darkItemSelectedBg: 'rgba(99, 102, 241, 0.2)',
      darkItemHoverBg: 'rgba(99, 102, 241, 0.1)',
    },
    Card: {
      colorBgContainer: 'rgba(30, 41, 59, 0.8)',
    },
    Table: {
      colorBgContainer: 'transparent',
      headerBg: '#1e293b',
      rowHoverBg: 'rgba(99, 102, 241, 0.1)',
    },
  },
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <ConfigProvider locale={zhTW} theme={darkThemeConfig}>
        <App />
      </ConfigProvider>
    </QueryClientProvider>
  </React.StrictMode>,
)
